import { Page, Pageable } from 'src/app/utils/pageable';
import * as LessonsV3 from '../../model/v3/lessons';

export class LessonBundlesUtilsV3 {
  /**
   * Credit counters have to cover every bundle a student owns, not just the page shown in a
   * listing - otherwise the total silently drops whatever does not fit on the page.
   */
  public static readonly ALL_BUNDLES_PAGE_SIZE = 1000;

  public static allBundlesPageable(): Pageable {
    return Pageable.of(0, LessonBundlesUtilsV3.ALL_BUNDLES_PAGE_SIZE, null);
  }

  public static sumAvailableCredits(page: Page<LessonsV3.LessonBundle> | null): number {
    return (page?.content ?? []).reduce((total, bundle) => total + (bundle.available ?? 0), 0);
  }

  public static creditsByProductCode(page: Page<LessonsV3.LessonBundle> | null): Map<string, number> {
    const credits = new Map<string, number>();
    (page?.content ?? []).forEach((bundle) => {
      const code = bundle.product?.code;
      if (!code) {
        return;
      }
      credits.set(code, (credits.get(code) ?? 0) + (bundle.available ?? 0));
    });
    return credits;
  }
}
